<template>
  <div class="psReportsPanel">
    <ps-upper-bar :site="{ site: 'Reportes' }"></ps-upper-bar>
    
    <ps-reports-item reportName="Altas y Bajas" path="altas-y-bajas"></ps-reports-item>  
  </div>
</template>

<script>
import PsUpperBar from '@/components/layout/PsUpperBar.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import PsReportsItem from './widgets/PsReportsItem.vue'

export default {
  name: 'PsReportsPanel',
  components: { PsUpperBar, PsReportsItem },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      configProjected: {
        amount: {
          color: 'white',
          'background-color': '#3E8091',  
        },
        labelIndicator: {
          text: 'Proyectado',
          color: 'black'
        },
      },
      configIncomings: {
        amount: {
          color: '#3E8091',
          'background-color': 'white',   
        },
        labelIndicator: {
          text: 'Ingresado',
          color: 'black'
        },
      },
    }
  },
  computed: {
    ...mapState(['isMobile']),
  },
  methods: {
  },
  async created () {
  }
}
</script>

<style scoped>
  .psReportsPanel { overflow-y: scroll; height: 100%; padding-bottom: 100px;}
  .psReportsPanel::-webkit-scrollbar { display: none; }

  .rowDateFilter { display: flex; width: 500px}
  .containerIndicator { 
    display: flex; 
    flex-direction: column; 
    background-color: white; 
    padding: 25px; 
    border-radius: 20px; 
    width: 100%; 
    margin-bottom: 30px;
    margin-top: 20px;
    box-shadow: 0px 1px 2px 1px #bbb;
  }
  .titlesIndicators { display: flex; width: 100%; font-size: 14px; font-weight: bold; margin-bottom: 8px;}
  .title { font-size: 1rem; font-weight: bold; text-align: left; margin-bottom: 15px }
  
  .rowIndicators { 
    display: flex; 
    justify-content: flex-start;
    width: 100%; 
    border-radius: 8px; 
    box-shadow: 0px 1px 2px 1px #bbb; 
    padding: 16px 0; 
    font-weight: bold;
    font-size: 21px;
    margin-bottom: 8px;
  }

  .titleMobile { display: none}
  .percentageIndicador { color: #444; padding-left: 20px}

  .containerAccounts { 
    display: flex; 
    flex-wrap: wrap;
    justify-content: space-between;
    background-color: white; 
    padding: 25px; 
    border-radius: 20px;  
    margin-top: 10px;
    box-shadow: 0px 1px 2px 1px #bbb;
    margin-bottom: 30px;
    width: 100%;
  }

  .containerAccounts > .administrator { display: flex; flex-direction: column; width: 46%; margin-right: 20px; margin-bottom: 60px }
  .containerAccounts > .administrator > .name { font-size: 1.25rem; line-height: 2.25rem; font-weight: bold; text-align: left; align-self: flex-start; margin-bottom: 20px}
  .accountsTitles { color: #3E8091; font-size: 14px; font-weight: bold; display: flex; border-bottom: 1px solid #eee; padding-bottom: 8px; }
  .accountsTitles > .w-25, .accountRow > .w-25, .accountsTotals > .w-25 { text-align: right;}

  .accountRow { display: flex; border-bottom: 1px solid #eee; padding: 8px 0 }

  .accountsTotals { display: flex; margin-top: 24px;}
  .accountsTotals > .w-25 { font-weight: bold; }

  .contentTableRecords { overflow-y: scroll; height: 80%; padding: 0 5px; }
  .contentTableRecords::-webkit-scrollbar { display: none}
  .tableTitles { display: flex; padding-left: 15px ;}
  .titlePrimary, .titleBlack { color: #0290af; font-weight: bold; font-size: 0.9rem; margin-bottom: 10px; text-align: left;}
  .titleBlack { color: black; width: 120px;}

  .date {width: 100px}
  .concept {width: 120px}
  .type {width: 100px}
  .entity {width: 220px}
  .total { width: 140px}

  .totalRow { display: flex; font-weight: bold; margin-top: 5px;}
  .totalRow > .totalLabel { width: 540px; padding: 5px 150px 5px; text-align: right;}
  .totalRow > .total { padding: 5px; text-align: left;}
  .totalRow > .totalMilagros { width: 120px; background-color: #60E2FF; padding: 5px; text-align: left;}
  .totalRow > .total { padding: 5px}
  .totalRow > .totalSofia { width: 120px; background-color: #3E8091; padding: 5px; text-align: left}
  .linkDetailAccount { cursor: pointer}

  .accumulatesOficial { background-color: #ffdced }


    /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) {
    .tooltip { display: none;}    
    .rowDate { flex-direction: column; }

    .rowDateFilter { width: 100%; margin-bottom: 25px}
    .containerIndicator { width: auto;}
    .containerIndicator > .row { align-items: center;}
    .psIndicatorAmount { min-width: 250px;}

    .projected > .titlesIndicators { display: none}
    .projected > .rowIndicators { flex-direction: column; align-items: center;}
    .projected > .rowIndicators > div { width: 75%; margin-bottom: 25px}

    .titleMobile { display: inline; font-size: 0.75rem; margin-bottom: 5px;}
    .concept, .type, .titleBlack { display: none}
    .date { width: 120px}
    .containerAccounts > .administrator { width: 100%; font-size: 0.85rem;}
    .containerAccounts > .administrator .w-25 { width: 50%}
    
    .maxAccount { display: none}
    .totalRow { margin-top: 15px }
    .totalRow > .totalLabel { width: 300px; text-align: left; padding: 5px 0 5px 30px;}
    .totalRow > .totalMilagros, .totalRow > .totalSofia { display: none;}
    .linkDetailAccount {
      border: 1px solid #ddd; margin-bottom: 10px; padding: 5px; border-radius: 8px; position: relative
    }
    .btnPointMobile { font-size: 20px; position: absolute; bottom: 15px; right: 10px}
  }

</style>